import { homeApi as api } from './homeApi';
export const addTagTypes = ['user'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      userInsightsBarGraphV2: build.query<
        UserInsightsBarGraphV2ApiResponse,
        UserInsightsBarGraphV2ApiArg
      >({
        query: queryArg => ({
          url: `/user/insights/bar_graph_v2/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset,
            status_history: queryArg.statusHistory,
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
            country: queryArg.country,
            country_id: queryArg.countryId,
            state_id: queryArg.stateId,
            district_id: queryArg.districtId
          }
        }),
        providesTags: ['user']
      }),
      userInsightsPieChartV2: build.query<
        UserInsightsPieChartV2ApiResponse,
        UserInsightsPieChartV2ApiArg
      >({
        query: queryArg => ({
          url: `/user/insights/pie_chart_v2/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset,
            trend: queryArg.trend,
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
            country: queryArg.country,
            country_id: queryArg.countryId,
            state_id: queryArg.stateId,
            district_id: queryArg.districtId
          }
        }),
        providesTags: ['user']
      }),
      userVolunteerUnpausedLineChartV2: build.query<
        UserVolunteerUnpausedLineChartV2ApiResponse,
        UserVolunteerUnpausedLineChartV2ApiArg
      >({
        query: queryArg => ({
          url: `/user/volunteer_unpaused/line_chart_v2/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset,
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
            country: queryArg.country,
            country_id: queryArg.countryId,
            state_id: queryArg.stateId,
            district_id: queryArg.districtId
          }
        }),
        providesTags: ['user']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type UserInsightsBarGraphV2ApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: any;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserInsightsBarGraphV2ApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Status History */
  statusHistory?: boolean;
  /** Start of the date range (YYYY-MM-DD) */
  startDate?: string;
  /** End of the date range (YYYY-MM-DD) */
  endDate?: string;
  /** Country uuid or all */
  country?: string;
  /** Country uuid */
  countryId?: string;
  /** State uuid */
  stateId?: string;
  /** District uuid */
  districtId?: string;
};
export type UserInsightsPieChartV2ApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: any;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserInsightsPieChartV2ApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Trend , Week, Month, Year */
  trend?: string;
  /** Start of the date range (YYYY-MM-DD) */
  startDate?: string;
  /** End of the date range (YYYY-MM-DD) */
  endDate?: string;
  /** Country uuid or all */
  country?: string;
  /** Country uuid */
  countryId?: string;
  /** State uuid */
  stateId?: string;
  /** District uuid */
  districtId?: string;
};
export type UserVolunteerUnpausedLineChartV2ApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: AggregatedData[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserVolunteerUnpausedLineChartV2ApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Start of the date range (YYYY-MM-DD) */
  startDate?: string;
  /** End of the date range (YYYY-MM-DD) */
  endDate?: string;
  /** Country uuid or all */
  country?: string;
  /** Country uuid */
  countryId?: string;
  /** State uuid */
  stateId?: string;
  /** District uuid */
  districtId?: string;
};
export type AggregatedData = {
  Jan: number;
  Feb: number;
  Mar: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
};
export const {
  useUserInsightsBarGraphV2Query,
  useUserInsightsPieChartV2Query,
  useUserVolunteerUnpausedLineChartV2Query
} = injectedRtkApi;
